import { createSelector } from 'reselect'
import { selectIssuerIdFromState } from 'src/app/RegisterAccount/redux/registerAccount.selectors'
import {
  IssuerIntegratorListModel,
  IssuerIntegratorListResponse,
} from 'src/models/issuerIntegrator.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectIssuerIntegratorListResponsesFromState = (
  state: RootState,
): Record<string, IssuerIntegratorListResponse> =>
  state.data.issuerIntegrators.listResponses

export const selectIssuerIntegratorListModelsFromState = createSelector(
  [selectIssuerIntegratorListResponsesFromState],
  (creditCardListResponses) =>
    Object.values(creditCardListResponses).reduce<
      Record<IssuerIntegratorListResponse['id'], IssuerIntegratorListModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new IssuerIntegratorListModel(curr),
      }),
      {},
    ),
)

const selectIssuerIntegratorOrderFromState = (state: RootState): string[] =>
  state.data.issuerIntegrators.order
export const selectIssuerIntegratorListModelList = createSelector(
  [
    selectIssuerIntegratorListModelsFromState,
    selectIssuerIntegratorOrderFromState,
  ],
  (issuerIntegrators, idList) => idList.map((id) => issuerIntegrators[id]),
)

export const selectIssuerIntegratorFromState = createSelector(
  [selectIssuerIdFromState, selectIssuerIntegratorListModelsFromState],
  (id, issuerIntegrators) =>
    Object.values(issuerIntegrators).find(
      (issuerIntegrator) => issuerIntegrator.id === id,
    ),
)
